"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function BriefcaseThin12Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("g", { id: "Icon", clipPath: "url(#clip0_1821_404)" },
            react_1.default.createElement("path", { id: "Icon_2", fillRule: "evenodd", clipRule: "evenodd", d: "M8.95852 2.5H10C11.1046 2.5 12 3.39543 12 4.5V8.5C12 8.87014 11.7989 9.19331 11.5 9.36622V10.5C11.5 11.3284 10.8284 12 10 12H2C1.17157 12 0.5 11.3284 0.5 10.5V9.36622C0.201099 9.19331 0 8.87014 0 8.5V4.5C0 3.39543 0.895431 2.5 2 2.5H3.04148C3.27952 1.08114 4.5135 0 6 0C7.4865 0 8.72048 1.08114 8.95852 2.5ZM4.58535 2.5H7.41465C7.20873 1.9174 6.65311 1.5 6 1.5C5.34689 1.5 4.79127 1.9174 4.58535 2.5ZM2 4C1.72386 4 1.5 4.22386 1.5 4.5V8H10.5V4.5C10.5 4.22386 10.2761 4 10 4H2ZM2 10.5L2 9.5H10V10.5H2Z", fill: "#D8DADE" })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: "clip0_1821_404" },
                react_1.default.createElement("rect", { width: 12, height: 12, fill: "white" }))));
}
function BriefcaseThin12(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(BriefcaseThin12Svg, Object.assign({}, svgProps)));
}
exports.default = BriefcaseThin12;
//# sourceMappingURL=BriefcaseThin12.js.map